import {
  DropDownTreeChangeEvent,
  DropDownTreeOpenEvent,
  DropDownTreeProps,
  DropDownTree as KendoDropdownTree,
} from '@progress/kendo-react-dropdowns';
import _ from 'lodash';
import { ReactNode } from 'react';
import { createRoot } from 'react-dom/client';
import { ValidationError } from '../../apps/benefit/models/Errors';
import ErrorViewer from './ErrorViewer';

interface DropdownTreeCustomProps {
  controlClassName?: string;
  popupClassName?: string;
  mandatory?: boolean;
  helper?: string;
  errors?: ValidationError[];
  clearErrors?: () => void;
  footer?: ReactNode;
}

type DropdownTreeProps = DropdownTreeCustomProps & DropDownTreeProps;

export default function DropdownTree(props: DropdownTreeProps) {
  const {
    errors,
    onChange,
    clearErrors,
    label,
    id,
    controlClassName,
    popupClassName,
    mandatory,
    helper,
    onOpen,
    footer,
  } = props;

  const internalOnChange = (e: DropDownTreeChangeEvent) => {
    if (errors?.length) {
      clearErrors?.();
    }
    onChange?.(e);
  };

  const classNames = `control-group ${controlClassName ?? ''} ${
    errors ? 'control-error' : ''
  }`.trim();

  const popupSettings = {
    className: popupClassName,
  };

  const setFooter = () => {
    if (!footer) return;

    const popup = document.getElementsByClassName('k-treeview')[0];
    if (!popup) return;

    const div = document.createElement('div');
    createRoot(div).render(footer);
    popup.appendChild(div);
  };

  const internalOnOpen = (e: DropDownTreeOpenEvent) => {
    onOpen?.(e);
    setTimeout(setFooter, 0);
  };

  return (
    <div className={classNames}>
      <div className="control-content">
        {!!label && (
          <label htmlFor={id}>
            {label}
            {mandatory && <sup>*</sup>}
          </label>
        )}
        <KendoDropdownTree
          {..._.omit(props, [
            'label',
            'popupSettings',
            'mandatory',
            'clearErrors',
          ])}
          onChange={internalOnChange}
          onOpen={internalOnOpen}
          popupSettings={popupSettings}
        />
      </div>
      {!!helper && <div className="control-info">{helper}</div>}
      <ErrorViewer errors={errors} />
    </div>
  );
}
